/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BarterSubjectSearchDto } from './barterSubjectSearchDto.model';


export interface ListResponseBarterSubjectSearchDto { 
    itemCount?: number;
    items?: Array<BarterSubjectSearchDto>;
    params?: { [key: string]: any; };
}

